export default __webpack_public_path__ + "static/media/correct15.b12baf06.mp3";